module.exports = __webpack_public_path__ + "static/media/vdbg.2d7d3f90.jpg";